var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-button",class:{loading: _vm.loading}},[_c('div',[_vm._t("default")],2),_vm._v(" "),_c('div',[(_vm.loading || _vm.delayLoading)?_c('Spinner'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }